<div>
    <div class="dialog-header flex justify-between items-center bg-sky-600 text-white p-3">
        <h6 class=" text-white" style="font-weight: 500;">Training Attandance ( {{attdate | date:'yyyy-MM-dd'}} ) </h6>
        <button mat-icon-button mat-dialog-close class="text-white">
            <mat-icon>close</mat-icon>
        </button>
    </div>    
    <mat-dialog-content class="p-4">
        <fieldset class="my-3">
            <legend>Training Attandance Entry</legend>
            <div id="others">
                <div style="overflow-x: auto; white-space: nowrap;">
                    <table >
                        <thead>
                            <tr>
                                <th>Sl No</th>
                                <th>Participate Name</th>
                                <th>Attandance Status</th>
                            </tr>
                        </thead>
                
                        <tbody>
                            <tr *ngFor="let p of participants; let i = index">
                                <td class="p-2 border">{{ i + 1 }}</td>
                                <td class="p-2 border">{{ p.name }}</td>
                                <td class="p-2 border">
                                    <mat-radio-group [(ngModel)]="p.attendance" class="flex gap-4">
                                    <mat-radio-button value="Yes">Yes</mat-radio-button>
                                    <mat-radio-button value="No">No</mat-radio-button>
                                    </mat-radio-group>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <fieldset class="mt-2">
                <legend>Image Uploads</legend>
                    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-x-3">
                        <!-- Food -->
                        <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Food</mat-label>
                            <input type="text" matInput [value]="foodFileName" placeholder="Choose a file" readonly />
                            <a mat-icon-button matSuffix (click)="fileInputFood.click()">
                            <mat-icon>attach_file</mat-icon>
                            </a>
                        </mat-form-field>
                        <input type="file" #fileInputFood (change)="onFileSelected($event, 'foodFile')" hidden />
                        </div>

                        <!-- Training Material -->
                        <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Training Material</mat-label>
                            <input type="text" matInput [value]="materialFileName" placeholder="Choose a file" readonly />
                            <a mat-icon-button matSuffix (click)="fileInputMaterial.click()">
                            <mat-icon>attach_file</mat-icon>
                            </a>
                        </mat-form-field>
                        <input type="file" #fileInputMaterial (change)="onFileSelected($event, 'materialFile')" hidden />
                        </div>
                        <div>
                        <mat-form-field appearance="outline">
                            <mat-label>Environment</mat-label>
                            <input type="text" matInput [value]="envionmentFileName" placeholder="Choose a file" readonly />
                            <a mat-icon-button matSuffix (click)="fileInputEnv.click()">
                            <mat-icon>attach_file</mat-icon>
                            </a>
                        </mat-form-field>
                        <input type="file" #fileInputEnv (change)="onFileSelected($event, 'environmentFile')" hidden />
                        </div>
                    
                    </div>
            </fieldset>  
            <div class="flex flex-row justify-center gap-4 my-4">
                <button type="button" mat-dialog-close class="btn-action-back">
                    <span class="material-symbols-outlined">arrow_left_alt</span>
                    Go Back
                </button>
                <button type="button" class="btn-action-refresh">
                    <span class="material-symbols-outlined">refresh</span>
                    Refresh
                </button>
                <button type="button" class="btn-action-save">
                    <span class="material-symbols-outlined">save</span>
                    Save
                </button>
            </div>
        </fieldset>
    </mat-dialog-content>
</div>    